import type { Chain } from "viem";
import {
  mainnet,
  optimism,
  cronos,
  bsc,
  gnosis,
  unichain,
  polygon,
  monad,
  sonic,
  fantom,
  boba,
  zksync,
  worldchain,
  hyperEvm,
  polygonZkEvm,
  moonbeam,
  moonriver,
  sei,
  soneium,
  kava,
  abstract as abstractChain,
  mantle,
  zora,
  base,
  plasma,
  mode,
  arbitrum,
  celo,
  avalanche,
  ink,
  linea,
  berachain,
  blast,
  plumeMainnet,
  scroll,
  katana,
  aurora,
} from "viem/chains";

/**
 * Static viem chain mapping for wallet config (wagmi).
 * Only contains chainId → viem Chain object.
 * All other metadata (name, explorerUrl, logoUri) comes from the /v1/chains API.
 */
export const VIEM_CHAINS: Record<number, Chain> = {
  1: mainnet,
  10: optimism,
  25: cronos,
  56: bsc,
  100: gnosis,
  130: unichain,
  137: polygon,
  143: monad,
  146: sonic,
  250: fantom,
  288: boba,
  324: zksync,
  480: worldchain,
  999: hyperEvm,
  1101: polygonZkEvm,
  1284: moonbeam,
  1285: moonriver,
  1329: sei,
  1868: soneium,
  2222: kava,
  2741: abstractChain,
  5000: mantle,
  7777777: zora,
  8453: base,
  9745: plasma,
  34443: mode,
  42161: arbitrum,
  42220: celo,
  43114: avalanche,
  57073: ink,
  59144: linea,
  80094: berachain,
  81457: blast,
  98866: plumeMainnet,
  534352: scroll,
  747474: katana,
  1313161554: aurora,
};

export function getViemChain(chainId: number): Chain | undefined {
  return VIEM_CHAINS[chainId];
}
